<template>
    <div class="form-black">
        <img :src="'/images/cars-withdrawal-1-v1.png'" :alt="`AutoBesikos Withdrawal Now`" width="685" height="358">
        <h2>Απόσυρση ΤΩΡΑ έως 3.000€!</h2>
        <p>Αν έχεις παλιό αυτοκίνητο, ήρθε η στιγμή να το αξιοποιήσεις!</p>
        <Button href="/vehicles" @click="updateStorage" inline>Δες αυτοκίνητα</Button>
    </div>
</template>

<script>
    import Button from "../Button/Button.vue";

    export default {
        components: {
            Button,
        },
        props: {
            interestFor: String,
            page: String,
        },
        setup(props, { slots, attrs }) {
            return { };
        },
        data() {
            return {
            }
        },
        methods: {
            updateStorage() {
                if ( !window.localStorage.getItem('withdrawal_autobesikos_2026') ) {
                    window.localStorage.setItem('withdrawal_autobesikos_2026', true);
                    this.$global.popup.open = false;
                    this.$global.popup.id = null;
                }
            },
        },
    }
</script>